import type { OperatorOption } from "src/base-components/FilterPopover/types";
import { getOperatorDefinition, OPERATORS } from "src/constants/operators";

const ONE_OF_OPTION: OperatorOption = {
  key: "one_of",
  value: { description: "One of", code: "one of" },
};

const IS_NONE_OPTION: OperatorOption = {
  key: "is_none",
  value: OPERATORS.is_none,
};

const stringOps: OperatorOption[] = [
  { key: "eq", value: OPERATORS.eq },
  { key: "str_contains", value: getOperatorDefinition("str_contains") },
  { key: "starts_with", value: getOperatorDefinition("starts_with") },
  { key: "ends_with", value: getOperatorDefinition("ends_with") },
  IS_NONE_OPTION,
];

const numericOps: OperatorOption[] = [
  { key: "eq", value: OPERATORS.eq },
  { key: "lt", value: OPERATORS.lt },
  { key: "le", value: OPERATORS.le },
  { key: "gt", value: OPERATORS.gt },
  { key: "ge", value: OPERATORS.ge },
  IS_NONE_OPTION,
];

const booleanOps: OperatorOption[] = [
  { key: "eq", value: OPERATORS.eq },
  IS_NONE_OPTION,
];

const enumOps: OperatorOption[] = [ONE_OF_OPTION, IS_NONE_OPTION];

const tagsOps: OperatorOption[] = [
  { key: "contains", value: OPERATORS.contains },
  IS_NONE_OPTION,
];

const dateOps: OperatorOption[] = [
  { key: "eq", value: OPERATORS.eq },
  { key: "lt", value: OPERATORS.lt },
  { key: "le", value: OPERATORS.le },
  { key: "gt", value: OPERATORS.gt },
  { key: "ge", value: OPERATORS.ge },
  IS_NONE_OPTION,
];

export const BUILT_IN_OPERATORS: Record<string, OperatorOption[]> = {
  string: stringOps,
  number: numericOps,
  integer: numericOps,
  boolean: booleanOps,
  enum: enumOps,
  tags: tagsOps,
  date: dateOps,
  datetime: dateOps,
};
